var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1958 11.7082C47.3932 8.02295 52.6068 8.02296 53.8042 11.7082L60.3276 31.7852C60.8631 33.4333 62.399 34.5491 64.1319 34.5491H85.2421C89.117 34.5491 90.7281 39.5076 87.5932 41.7852L70.5147 54.1935C69.1128 55.2121 68.5261 57.0175 69.0616 58.6656L75.585 78.7427C76.7825 82.4279 72.5645 85.4924 69.4297 83.2148L52.3511 70.8065C50.9492 69.7879 49.0508 69.7879 47.6489 70.8065L30.5703 83.2148C27.4355 85.4924 23.2176 82.4279 24.415 78.7426L30.9384 58.6656C31.4739 57.0175 30.8872 55.2121 29.4853 54.1935L12.4068 41.7852C9.27191 39.5076 10.883 34.5491 14.7579 34.5491H35.8681C37.601 34.5491 39.1369 33.4333 39.6724 31.7852L46.1958 11.7082Z",
    fill: "#D1DCE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/EmptyStar.2df9fa25.svg";
export { ForwardRef as ReactComponent };